import React, { useMemo } from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableRow({ id, title, subtitle }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    cursor: 'grab',
  };

  return (
    <Flex
      ref={setNodeRef}
      style={style}
      border='1px solid #4a5568'
      borderRadius={12}
      p={3}
      align='center'
      justify='space-between'
      gap={3}
      bg={isDragging ? 'rgba(255,255,255,0.06)' : 'transparent'}
      {...attributes}
      {...listeners}
    >
      <Box>
        <Text color='white' fontWeight={700}>
          {title}
        </Text>
        {subtitle ? (
          <Text color='white' opacity={0.8} fontSize='sm'>
            {subtitle}
          </Text>
        ) : null}
      </Box>
      <Text color='white' opacity={0.8}>
        Trascina
      </Text>
    </Flex>
  );
}

export default function SortablePositionList({ items, onChangeOrder, onSave, isSaving }) {
  const ids = useMemo(() => items.map((i) => i.id), [items]);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = ids.indexOf(active.id);
    const newIndex = ids.indexOf(over.id);
    const next = arrayMove(items, oldIndex, newIndex);
    onChangeOrder(next);
  };

  return (
    <Box>
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={ids} strategy={verticalListSortingStrategy}>
          <Flex direction='column' gap={3}>
            {items.map((i) => (
              <SortableRow key={i.id} id={i.id} title={i.title} subtitle={i.subtitle} />
            ))}
          </Flex>
        </SortableContext>
      </DndContext>
      <Flex mt={4} justify='flex-end'>
        <Button onClick={onSave} isLoading={isSaving}>
          Salva ordine
        </Button>
      </Flex>
    </Box>
  );
}

